import { supabase } from "../supabase";


export const metrics__get_asker_stats = (
  limit: number,
  offset: number,
  startDate: string,
  endDate: string
) => {
  return supabase.rpc('metrics__get_asker_stats', {
    p_limit: limit,
    p_offset: offset,
    p_start_date: startDate,
    p_end_date: endDate,
  });
};

export const metrics__get_gender_stats = (startDate: string, endDate: string) => {
  return supabase.rpc('metrics__get_gender_stats', {
    start_date: startDate,
    end_date: endDate,
  });
};

export const metrics__dayblock_tasks_number = (start: string, end: string) => {
  return supabase.rpc('metrics__dayblock_tasks_number', {
    start_date: start,
    end_date: end,
  });
};

export const metrics__get_category_stats = (startDate: string, endDate: string) => {
  return supabase.rpc('metrics__get_category_stats', {
    start_date: startDate,
    end_date: endDate,
  });
}

export const metrics__get_top_communes = (startDate: string, endDate: string) => {
  return supabase.rpc('metrics__get_top_communes', {
    start_date: startDate,
    end_date: endDate,
  });
};

export const metrics__get_tasks_per_commune_per_sex = (startDate: string, endDate: string) => {
  return supabase.rpc(
    'metrics__get_tasks_per_commune_per_sex',
    {
      start_date: startDate,
      end_date: endDate,
    },
  );
}

export const metrics__get_category_timeblock_stats = (start: string, end: string) => {
  return supabase.rpc(
    'metrics__get_category_timeblock_stats',
    {
      start_date: start,
      end_date: end,
    },
  );
}

export const metrics__get_daily_sales =  (start: string, end: string) => {
  return supabase.rpc('metrics__get_daily_sales', {
    start_date: start,
    end_date: end,
  });
}

export const metrics__get_sales_per_helper = (start: string, end: string) => {
  return supabase.rpc(
    'metrics__get_sales_per_helper',
    {
      start_date: start,
      end_date: end,
    },
  )
}